// src/components/SEO.js
import React from 'react'
import { Helmet } from 'react-helmet'
import { useLocation } from 'react-router-dom'

const SITE_NAME = 'Sarah Adom Braiding Salon'
const DEFAULT_DESCRIPTION = 'Professional braiding, twists, cornrows and more in Manassas, VA. Book your appointment at Sarah Adom Braiding Salon.'
const DEFAULT_KEYWORDS = 'braiding salon Manassas VA, hair braiding near me, box braids, Senegalese twists, cornrows, African braiding, Sarah Adom Braiding Salon'
const SITE_URL = typeof window !== 'undefined' ? window.location.origin : ''
const GEO = { lat: 38.6316261, lng: -77.2721974 }

const SEO = ({ title, description, keywords, path }) => {
  const location = useLocation()
  const pathname = path !== undefined ? path : (location && location.pathname) || ''
  const fullTitle = title ? `${title} | ${SITE_NAME}` : SITE_NAME
  const desc = description || DEFAULT_DESCRIPTION
  const kw = keywords || DEFAULT_KEYWORDS
  const canonical = pathname ? `${SITE_URL}${pathname}` : SITE_URL

  const localBusinessSchema = {
    '@context': 'https://schema.org',
    '@type': 'HairSalon',
    name: SITE_NAME,
    description: DEFAULT_DESCRIPTION,
    url: SITE_URL,
    telephone: '703-936-3026',
    address: {
      '@type': 'PostalAddress',
      streetAddress: '10370 Festival Ln Ste.116',
      addressLocality: 'Manassas',
      addressRegion: 'VA',
      postalCode: '20109',
    },
    geo: {
      '@type': 'GeoCoordinates',
      latitude: GEO.lat,
      longitude: GEO.lng,
    },
    openingHoursSpecification: [
      { '@type': 'OpeningHoursSpecification', dayOfWeek: ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'], opens: '07:30', closes: '19:00' },
      { '@type': 'OpeningHoursSpecification', dayOfWeek: 'Sunday', opens: '10:00', closes: '18:00' },
    ],
  }

  return (
    <Helmet>
      <title>{fullTitle}</title>
      <link rel="canonical" href={canonical} />
      <meta name="description" content={desc} />
      <meta name="keywords" content={kw} />
      <meta name="viewport" content="width=device-width, initial-scale=1" />
      {/* Open Graph */}
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={desc} />
      <meta property="og:type" content="website" />
      <meta property="og:url" content={canonical} />
      <meta property="og:site_name" content={SITE_NAME} />
      <meta property="og:locale" content="en_US" />
      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={desc} />
      {/* Local business structured data */}
      <script type="application/ld+json">{JSON.stringify(localBusinessSchema)}</script>
    </Helmet>
  )
}

export default SEO
